import * as React from 'react';

// tslint:disable:max-line-length
export const AutoPitIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M6 3.875C6 2.529 8 .333 8 .333s2 2.2 2 3.542a2 2 0 1 1-4 0z" />
      <path d="M15.707 10.286l-.786-.786-.941-4.7A1 1 0 0 0 13 4h-1.224l1 5H3.22l1-5H3a1 1 0 0 0-.98.8l-.941 4.7-.786.786A1 1 0 0 0 0 11v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4a1 1 0 0 0-.293-.714zM3 13H2v-1h1v1zm11 0h-1v-1h1v1z" />
    </g>
  </svg>
);
